import { TypedPorcentagem } from '@acme/common'
import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Empresa } from './empresas'
import { Funcionario, FuncionarioCentroCusto } from './funcionario'
import { RegraCalculoPresenter } from './regras-calculo'

export const CreateImplantacaoSchema = zod.SaldoHorasSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    saldoAnteriorId: true,
    implantacao: true,
    funcionarioId: true,
    empresaId: true,
}).partial({
    porcentagemHorasExtras: true,
})

export type SaldoHoras = z.infer<typeof zod.SaldoHorasSchema> & {
    Funcionario?: Funcionario
    Empresa?: Empresa
}

export type SaldoHorasPorcentagens = {
    Funcionario?: {
        nome: string
        FuncionarioCentroCusto?: FuncionarioCentroCusto[]
        RegrasCalculo: RegraCalculoPresenter
    }
    CentroCusto?: {
        id: number
        nomeCentroCusto: string
    }
    empresaId: number
    tipoControle: string
    id: string
    /** Compensadas */
    horasExtras: string
    faltas: string
    porcentagemHorasExtras: TypedPorcentagem
    porcentagensCompesacao: TypedPorcentagem
    porcentagensPagamento: TypedPorcentagem
    totalCompensacao: string
    saldoAnterior?: string
    SaldoEspelho: SaldoHoras
    pagamentoTotal: string
    pagamentoFaltas: string
    saldo: string
    implantado?: boolean
}

type SaldoDiarioChildren = {
    Funcionario: Pick<Funcionario, 'FuncionarioCentroCusto'>
    id: string
    isChild: boolean
    tipoControle: string
    horasExtras: string
    faltas: string
    extras: string
    saldoDia: string
    acumuladoMes: string
    acumuladoBanco: string
    pagamento: string
    porcentagemHorasExtras: TypedPorcentagem
    competencia: string
    data: string
}

type SaldoDiarioParent = {
    Funcionario: Pick<Funcionario, 'FuncionarioCentroCusto'>
    id: string
    empresaId: number
    data: string
    horasExtras: string
    faltas: string
    extras: string
    saldoDia: string
    acumuladoMes: string
    acumuladoBanco: string
    pagamento: string
    porcentagemHorasExtras: TypedPorcentagem
    tipoControle: string
    children: Array<SaldoDiarioChildren>
}

export type SaldoHorasDiario = SaldoDiarioParent & SaldoDiarioChildren

export const saldoHoras = new ApiService<Omit<SaldoHoras, '__typename'>>(
    'saldo-horas',
)
export const saldoHorasV2 = new ApiService<
    SaldoHorasPorcentagens | SaldoHorasDiario
>('saldo-horas', 'v2')
